module.exports = __webpack_public_path__ + "static/media/history_24.7bc945e8.jpg";